import React, { useEffect, useState } from 'react';

// Importação da fonte Satisfy via CDN
const fontLink = document.getElementById('hostul-splash-font');
if (!fontLink) {
  const link = document.createElement('link');
  link.id = 'hostul-splash-font';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Satisfy&display=swap';
  document.head.appendChild(link);
}

const SplashScreenH = ({ show, onFinish }) => {
  const [showFill, setShowFill] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (show) {
      setShowFill(false);
      setPulse(false);
      const timer1 = setTimeout(() => {
        setShowFill(true);
        setPulse(true);
      }, 1500);
      const timer2 = setTimeout(() => {
        onFinish();
      }, 2000);
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }
  }, [show, onFinish]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500"
      style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #2d145e 50%, #1a1a2e 100%)',
        backgroundSize: '300% 300%',
        animation: 'gradientMoveSutil 8s ease-in-out infinite',
        width: '100vw',
        height: '100vh',
        left: 0,
        top: 0,
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      }}
    >
      <svg
        width="420"
        height="120"
        viewBox="0 0 420 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontFamily="'Satisfy', cursive"
          fontSize="80"
          fill={showFill ? '#fff' : 'transparent'}
          stroke="#fff"
          strokeWidth="0.3"
          paintOrder="stroke fill"
          style={{
            filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.18))',
            strokeDasharray: 1200,
            strokeDashoffset: 1200,
            animation: `hostulWrite 1.5s cubic-bezier(0.4,0,0.2,1) forwards${pulse ? ', hostulScaleUp 0.4s cubic-bezier(0.4,0,0.2,1) forwards' : ''}`,
            transition: 'fill 0.3s cubic-bezier(0.4,0,0.2,1)',
            transformOrigin: '50% 60%',
          }}
        >
          Hostul
        </text>
        <style>{`
          @keyframes hostulWrite {
            to { stroke-dashoffset: 0; }
          }
          @keyframes gradientMoveSutil {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          @keyframes hostulScaleUp {
            from { transform: scale(1); }
            to { transform: scale(1.12); }
          }
        `}</style>
      </svg>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Satisfy&display=swap');
      `}</style>
    </div>
  );
};

export default SplashScreenH; 